import { combineReducers } from "redux";
import featured from "./featuredCategoriesReducer";

// import fees from "./deliveryFeesReducer";
export default combineReducers({
  featured,
});
